import React from 'react';
import { costItems } from '../data/content';
export function CostOfStaying() {
  return <section aria-labelledby="costo-title" className="w-full bg-cream-50 px-5 py-20 sm:py-24" data-id="element-30" data-mp="1gpyhjcs30jtf">
      <div className="mx-auto max-w-content" data-id="element-31" data-mp="12pxhfzjn5gf0">
        <h2 id="costo-title" className="max-w-2xl text-center font-display text-4xl font-semibold leading-tight tracking-tight text-plum-800 sm:text-left sm:text-5xl" data-id="element-32" data-mp="12r8me2otou7p">
          El costo real de seguir sin el sistema correcto
        </h2>

        <ul className="mt-12 divide-y divide-cream-300 border-y border-cream-300" data-id="element-33" data-mp="1zg6hxn4ecw5x">
          {costItems.map(item => <li key={item.title} className="flex gap-4 py-5 sm:gap-6" data-id="element-34" data-mp="1lnqh8syyxa86">
              <span aria-hidden="true" className="mt-2 h-2 w-2 shrink-0 rounded-full bg-alert" data-id="element-35" data-mp="1ppbtqd7lbmhu" />
              <div className="sm:flex sm:flex-1 sm:items-baseline sm:gap-6" data-id="element-36" data-mp="2dffw6h91lg79">
                <h3 className="text-base font-semibold text-plum-800 sm:w-64 sm:shrink-0" data-id="element-37" data-mp="2i6eh5u4z72gu">
                  {item.title}
                </h3>
                <p className="mt-1 text-base leading-relaxed text-plum-500 sm:mt-0" data-id="element-38" data-mp="3he3995gaodsb">{item.text}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}